import Vue from 'vue';
import 'globalthis/auto';
import App from './App.vue';
import store from './store';
import router from './router';
import VCharts from 'v-charts';
import Element from 'element-ui';
import DateWeekRange from 'date-week-range';
import iView from 'iview';
import {
  isInGame,
  clearLoginInfoFromCookie,
  checkClientLogin,
} from './utils';
import {
  ensureSecuritySensitiveVerify,
  isSecurityVerifyDebugBypass,
  setSecurityVerifyDebugBypass,
  requestSecuritySensitiveVerify,
} from './utils/securitySensitiveVerify';
import CloudServer from '../../cloudserver/index';

import './assets/styles/reset.scss';
import './assets/styles/element-variables.scss';
import './assets/styles/cascader.css';
import './permission'; // 处理权限
import Track from '@mini1/track';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import VueEllipsis from 'vue-ellipsis-component';
const VUE_APP_ENV = process.env.VUE_APP_ENV; // vue应用运行环境
// 新版埋点上报
const { ReportService, UserService } = window.MiniService;
const mUserNavigator = navigator.userAgent
  .toLowerCase()
  .match(/iphone|android/);
let device = (mUserNavigator && mUserNavigator[0]) || 'pc';

Sentry.init({
  Vue,
  attachProps: true, // 捕获props的报错
  logErrors: true, // 保留控制台错误输出
  tracingOptions: {
    trackComponents: true,
  },
  dsn: 'https://7dde881fb2ce4f7082aec4efe8d72ffa@cloud-sentry.mini1.cn/26',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router), // router切换变化检测
    }), // 浏览器性能追踪
  ],
  enabled: VUE_APP_ENV === 'prod', // 正式环境开启sentry 设为false时sentry服务不会开启
  environment: VUE_APP_ENV || 'prod', // 应用环境
  sampleRate: VUE_APP_ENV === 'prod' ? 0.25 : 1, // 在生产环境一般不要把sampleRate设置为1，尤其是在高并发的系统中
  tracesSampleRate: VUE_APP_ENV === 'prod' ? 0.25 : 1, // 在生产环境一般不要把tracesSampleRate设置为1，尤其是在高并发的系统中
  attachStacktrace: true,
  logLevel: 1, // sentry sdk内部错误会被记录 可不设置
  maxBreadcrumbs: 50,
  ignoreErrors: [
    /^Redirected when going from/,
    /^Navigation cancelled from/,
    /^Loading CSS chunk chunk/,
    /^Avoided redundant navigation to current location:/,
  ],
});
//埋点
Track.init({
  strict: true, // 默认严格模式，即按 v1-v5 加 k 值的方式上报；该值为false时，不走内部大数据上报
  autoCheckSys: true, //自动检测系统
  sysMap: {
    pc: 'PC',
    android: 'H5',
    iphone: 'H5',
  },
  infokey: 'userInfo',
  commonParams: null,
});
Vue.use(VCharts);
Vue.use(VueEllipsis);
Vue.use(Element);
Vue.use(DateWeekRange);
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.$log = Track.log.bind(Track);
const init = async () => {
  // 保存用户信息
  const userInfo = await checkClientLogin();
  // console.log('userInfo', userInfo);
  UserService.init(isInGame ? 1 : 2, userInfo);
  const Report = (type, name, vParams = {}) => {
    if (ReportService) {
      ReportService(71005, 10024)[type](name, {
        ...vParams,
        v1: device === 'pc' ? 3 : device === 'iphone' ? 1 : 2,
        v2: 1,
      });
    }
  };
  Vue.prototype.Report = Report;
  Vue.prototype.$ensureSecuritySensitiveVerify = options =>
    ensureSecuritySensitiveVerify(store, options);
  // 向 cloudserver 注入安全校验回调，兑换商品前会触发
  CloudServer.setSecurityVerify(options =>
    requestSecuritySensitiveVerify(store, {
      oncePerSession: false,
      ...options,
    }),
  );
  if (isSecurityVerifyDebugBypass()) {
    console.info(
      '[账户安全] 调试模式：独立密码/短信校验已默认跳过。关闭：localStorage.setItem("debug_security_verify_bypass","0") 并刷新，或 .env 设 VUE_APP_SECURITY_VERIFY_BYPASS=false',
    );
  }
  Vue.prototype.$setSecurityVerifyDebugBypass = setSecurityVerifyDebugBypass;
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
};

init();

if (!window.globalThis) {
  window.globalThis = window;
}
function receiveMessage(event) {
  if (~event.origin.indexOf('.mini1.cn') && event.data === 'MINI-LOGOUT') {
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('loginTime');
    clearLoginInfoFromCookie();
  }
}

window.addEventListener('message', receiveMessage, false);
